/* eslint-disable no-alert */
import { DROP_EVENT_REPORT_INIT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import invokeApiRequest from 'root/src/client/logic/api/util/invokeApiRequest'
import { MULTIGAME_DROP_REPORT_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import displayModal from 'root/src/client/logic/modal/actions/displayModal'

export default (dropEvent, itemFunctions, fnProps) => async (dispatch, getState) => {
	const state = getState()

	const isReportByGame = await new Promise(resolve => dispatch(
		displayModal(MULTIGAME_DROP_REPORT_MODAL_MODULE_ID, {
			onSubmit: resolve,
		}),
	))

	const payload = {
		dropEventId: dropEvent.id,
		isReportByGame,
		...fnProps,
	}

	const { body, error } = await invokeApiRequest(DROP_EVENT_REPORT_INIT, payload, state)

	if (error) {
		return alert(error.message)
	}

	const { responseEmail } = body
	return alert(`The report will be sent to ${responseEmail}`)
}
